$(function() {
	$("#form--postComment").submit(function(){
		
		$.ajax({
  			type: "POST",
			url: ele.uri.buildUrl("blogComment"),
			data: $(this).serialize(),
			dataType: "json",
			success: function(data) {
				var $dialog = ele.modal.confirm("Your comment has been added. You may need to wait for your comment to be approved before it becomes visible.");
				$dialog.parent().find(".ui-dialog-titlebar-close, button.e_cancel").hide();
				$("#form--postComment").find("#author_name, #content").val("");
			},
			error: function(data) {
				var $dialog = ele.modal.confirm("There was a problem adding your comment.");
				$dialog.parent().find(".ui-dialog-titlebar-close, button.e_cancel").hide();
			}
		});
		
		return false;
	});
	
});